import { Component } from 'react';

import { loadRoadmap } from 'common/actions/roadmaps';
import asyncConnect from 'common/core/asyncConnect';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import { findRoadmapByURLName } from 'common/util/roadmapUtils';

const asyncFetch = {
  promise: async ({ store: { dispatch, getState }, params }) => {
    if (!params.roadmapURLName) {
      return;
    }

    const state = getState();
    const roadmap = state.roadmaps?.roadmaps?.find((roadmap) => {
      return roadmap.urlName === params.roadmapURLName;
    });
    if (roadmap) {
      return;
    }

    // User must have loaded a past urlName this roadmap used to have
    return dispatch(loadRoadmap(params.roadmapURLName));
  },
};

class RoadmapContainer extends Component {
  static asyncConnect = asyncFetch;

  render() {
    const { children, params, roadmaps } = this.props;

    const roadmap = findRoadmapByURLName(roadmaps, params.roadmapURLName, []);

    return cloneElementWithProps(children, {
      ...this.props,
      roadmap,
    });
  }
}

export default asyncConnect([asyncFetch], (state) => ({
  oldURLNames: state.roadmaps?.oldURLNames,
}))(RoadmapContainer);
